import { useMutation } from '@tanstack/react-query';
import { PUBLIC_API } from 'utils/globalApiServices';
import PublicRealPlayHelper from 'features/publicRoleplay/publicRealPlay.helper';

const mutationFn = async ({ file }) => {
  const body = new FormData();
  body.append('file', file);

  const url = `/public/file/upload/`;
  const { data } = await PUBLIC_API.post(url, body);
  return data?.data;
};

const useUploadPublicRecordingFileMutation = () => {
  const { setTempVideoUrl, setIsLoadingVideoTemp } = PublicRealPlayHelper();
  return useMutation({
    mutationFn,
    onMutate: () => {
      setIsLoadingVideoTemp(true);
    },
    onSettled: () => {
      setIsLoadingVideoTemp(false);
    },
    onSuccess: (response) => {
      setTempVideoUrl(response?.url);
    },
    onError: () => {
      setTempVideoUrl('');
      console.log('Unable to upload video, please record again.');
    },
  });
};

export default useUploadPublicRecordingFileMutation;
